import ProductInventoryBalancev2 from '../pages/ProductInventoryBalancev2';

const productInventoryBalancev2Route = {
  public: [],
  auth: [
    {
      name: 'product_inventory_balance_v2',
      path: '/maintenance/product-inventory-balance-v2',
      permissions: ['admin', 'PM', 'GPM'],
      component: ProductInventoryBalancev2,
    },
  ],
};

export default productInventoryBalancev2Route;
